export default {"src":"/_next/static/media/privacy-preferences-icon.30285a86.svg","height":14,"width":30,"blurWidth":0,"blurHeight":0};